import { useEffect, useState, useContext } from 'react';
import { CompaignFilledContext } from '../../../../context/CompaignFilled';
import { getProgressDetails } from './ProgressDetails.services';
import { useToast } from '@welbe/web-design-system';

interface UseProgressDetailsProps {
	campaignId: string;
}

export const useProgressDetails = ({ campaignId }: UseProgressDetailsProps) => {
	const { toast } = useToast();
	const [progressDetailsData, setProgressDetailsData] = useState<any>([]);
	const [isLoading, setLoading] = useState(false);

	const { setFilledCampaign } = useContext(CompaignFilledContext);

	const fetchProgressDetails = async () => {
		setLoading(true);
		try {
			const { data } = await getProgressDetails(campaignId);
			setProgressDetailsData([
				{
					id: 'total',
					totalEmployees: data.content.totalEmployees,
					branchOfficeName: `${data.content.companyFancyName} - Total`,
					porcent: data.content.percentage,
					answeredEmployees: data.content.answeredEmployees,
					isNomCompleted: data.content.isNomCompleted,
				},
				...data.content.branchOffices.map((branchOffice: any) => ({
					id: branchOffice.id,
					totalEmployees: branchOffice.totalEmployees,
					branchOfficeName: `${data.content.companyFancyName} - ${branchOffice.name}`,
					porcent: branchOffice.percentage,
					answeredEmployees: branchOffice.answeredEmployees,
					isNomCompleted: branchOffice.isNomCompleted,
				})),
			]);
			setFilledCampaign(data.content.isNomCompleted);
		} catch (error) {
			toast.error(
				'Hubo un error al intentar procesar esta operación. Inténtalo de nuevo más tarde.',
			);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchProgressDetails();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [campaignId]);

	return {
		progressDetailsData: progressDetailsData.length ? progressDetailsData : [],
		isLoading,
	};
};
